import { render, staticRenderFns } from "./VsHelp.vue?vue&type=template&id=62c5b6c5&lang=pug&"
import script from "./VsHelp.vue?vue&type=script&lang=js&"
export * from "./VsHelp.vue?vue&type=script&lang=js&"
import style0 from "./VsHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c5b6c5')) {
      api.createRecord('62c5b6c5', component.options)
    } else {
      api.reload('62c5b6c5', component.options)
    }
    module.hot.accept("./VsHelp.vue?vue&type=template&id=62c5b6c5&lang=pug&", function () {
      api.rerender('62c5b6c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsHelp.vue"
export default component.exports